<template>
  <div class="div-block-6">
    <div class="header-column-new">
      <div class="logo-header">
        <img
          src="/images/left-arrow.svg"
          @click="close()"
          style="height: 60px; width: 60px; cursor: pointer; filter: invert(1)"
        />
      </div>
      <div class="center">
        <div class="logo-div">
          <div
            class="logo-img"
            :style="
              'background-image: url(\'' +
              logo +
              '\');background-position: 50% 50%;background-size: cover;'
            "
          ></div>
        </div>
      </div>
      <div class="header-div"></div>
    </div>
  </div>
</template>

<script>
import variables from "@/legends/variables.json"
export default {
  data: () => {
    return {
      app_logo: variables["logo"],
      slug: null,
    }
  },
  created() {
    this.slug = this.$route.params.slug
    
  },
  computed: {
    store: function () {
      return this.$store.state
    },
    logo: function () {
      return this.store.b2b.logo
    },
  },
  methods: {
    close() {
      if (this.$route.name == "events") {
        window.open(
          "https://announcement.themozo.app/announcement/events/" +
            this.slug +
            "/" +
            this.store.b2b.uid,
          "_self"
        )
      } else {
  
        if (this.store.b2b.url == 'adamandco') {
          window.open("https://themozo.app/adamandco", "_self")
        } else {
          window.open("https://guestpage.themozo.app/" + this.$route.query.gp_url, "_self")
        }
       
      }
    },
  },
}
</script>

<style scoped>
.logo-img {
  height: 60px;
  width: 60px;
  max-height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border-style: solid;
  border-color: #f4f4f4;
  border-width: 2px;
}

.small-img {
  width: 90px;
  height: 90px;
  border: 1px solid black;
}

.header-column-new {
  background-image: none;
  background-color: transparent;
  display: grid;
  display: -ms-grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 0% 5%;
  width: 100%;
}

.div-block-6 {
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-12 {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.header-div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
